export enum INVITATION_REQUEST_ID_LIST {
  GET_TNC_CONFIG = 'GET_TNC_CONFIG',
  GET_TNC_DETAIL = 'GET_TNC_DETAIL',
  POST_INVITATION_REGISTRATION = 'POST_INVITATION_REGISTRATION',
  GET_GENERAL_CONFIG = 'INVITATION_GET_GENERAL_CONFIG'
}
